<template>
  <gl-table-two-columns title="Summary" :rows="prepareData()" min-column-title />
  <!--  <address-details-summary-wallets v-if="false" />-->
</template>

<script>
import GlTableTwoColumns from '@gl/GlTableTwoColumns/GlTableTwoColumns'
// import AddressDetailsSummaryWallets from './components/AddressDetailsSummaryWallets'

export default {
  name: 'AddressDetailsSummary',
  components: { GlTableTwoColumns },
  props: {
    address: {
      type: String,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
  },
  methods: {
    prepareData() {
      return [
        {
          title: 'Address',
          value: this.address,
        },
        {
          title: 'No. Transactions',
          value: this.totalCount,
        },
      ]
    },
  },
}
</script>
